module.exports = __webpack_public_path__ + "img/logo-footer.8344dc25.jpg";